
import { Component, Prop, Vue } from 'vue-property-decorator';
import * as routeNames from '@/router/routeNames';

@Component({})
export default class PageCard extends Vue {
  @Prop({ type: String, required: false, default: 'Job Booking' }) public title!: string;
  @Prop({ type: String, required: false, default: 'Order a job in a convenient way for you:' })
  public subtitle!: string;
  @Prop({ type: String, required: false, default: routeNames.SPREADSHEET_JOB_BOOKING }) public link!: string;
  @Prop({ type: String, required: false, default: 'mdi-home' }) public icon!: string;
  @Prop({ type: Boolean, required: false, default: false }) public underConstruction!: boolean;

  private linkRouter = {
    name: this.link,
  };

  private mounted() {
    this.linkRouter = {
      name: this.link,
    };
    if (this.$router.resolve(this.linkRouter).resolved.matched.length === 0) {
      this.linkRouter.name = routeNames.JOB_BOOKING;
    }
  }
}
